/* eslint-disable */
var e = (function () {
    var e = navigator.userAgent.toLowerCase(),
      r = {};
    return (
      e.indexOf("android") > -1 || e.indexOf("adr") > -1
        ? (r.android = !0)
        : !e.match(/\(i[^;]+;( u;)? cpu.+mac os x/) || (r.ios = !0),
      r
    );
  })(),
  r = (function () {
    var e,
      r = navigator.userAgent.toLowerCase(),
      a = {};
    return (
      (e = "micromessenger" == r.match(/MicroMessenger/i))
        ? (a.wechat = !0)
        : (e = r.match(/scimall\/([\d.]+)/))
        ? (a.scimall = e[1])
        : (e = r.match(/innovationchina\/([\d.]+)/))
        ? (a.innovationChina = e[1])
        : !(e = r.match(/sciencechina\/([\d.]+)/)) || (a.scienceChina = e[1]),
      a
    );
  })();

function a(e) {
  var r = prompt(JSON.stringify(e));
  return r ? JSON.parse(r) : {};
}

function t(t) {
  (this.params = { handler: t }),
    (this.sendMessage = function (t) {
      if (r.scimall || r.scienceChina || r.innovationChina) {
        if (
          ((function (e, r) {
            for (var a in r) r.hasOwnProperty(a) && (e[a] = r[a]);
          })(this.params, t),
          this.params.async ||
            (this.params.parameters && this.params.parameters.async))
        ) {
          var n = this.params;
          return (
            n.parameters
              ? ((n.callbackID = n.parameters.callbackId),
                (n.callbackFunction = n.parameters.callbackFunction),
                delete n.parameters.async,
                delete n.parameters.callbackId,
                delete n.parameters.callbackFunction)
              : delete n.async,
            e.android
              ? a(n)
              : (function (e) {
                  console.log("postMessage", e, window.webkit);
                  window.webkit.messageHandlers.ScimallWKJavascriptBridge.postMessage(
                    e
                  );
                })(n)
          );
        }
        return a(this.params);
      }
    });
}

const n = new t("Common");
const o = new t("UI");
const i = new t("Business");
const s = new t("Storage");
const c = {
  name: "sma.js",
  version: "0.0.1",
  platform: e,
  isApp: r,
  appState: function (e, r) {
    return n.sendMessage({
      action: "AppState",
      callbackID: e,
      callbackFunction: r,
    });
  },
  idleTimer: function () {
    return n.sendMessage({ action: "IdleTimer" });
  },
  nativeLog: function (e) {
    n.sendMessage({ action: "NativeLog", parameters: e });
  },
  getToken: function () {
    return n.sendMessage({ action: "GetToken" });
  },
  login: function () {
    return n.sendMessage({ action: "StartLogin" });
  },
  share: function (e) {
    var r = { action: "Share", parameters: e };
    return i.sendMessage(r);
  },
  getWeChatAttention: function () {
    return i.sendMessage({ action: "WechatAttention" });
  },
  setShareInfo: function (e) {
    var r = { action: "TransShareInfo", parameters: e };
    return i.sendMessage(r);
  },
  getUserInfo: function () {
    return n.sendMessage({ action: "GetUserInformation" });
  },
  clearCache: function () {
    return n.sendMessage({ action: "CleanCache" });
  },
  getLocation: function (e, r) {
    return n.sendMessage({
      async: !0,
      action: "GetLocation",
      callbackID: e,
      callbackFunction: r,
    });
  },
  getNetState: function () {
    return n.sendMessage({ action: "GetNetState" });
  },
  getMobileUUID: function () {
    return n.sendMessage({ action: "GetDeviceInfo" });
  },
  getUserType: function () {
    return n.sendMessage({ action: "LoginType" });
  },
  hideNavBar: function () {
    return o.sendMessage({ action: "HideNaviBar" });
  },
  /**
   * 是否关闭侧滑返回
   * @param {*} isClose  1为关闭侧滑，0开启侧滑
   * @returns
   */
  sliderClose: function (isClose = 0) {
    return o.sendMessage({
      action: "SliderClose",
      parameters: { isClose: isClose },
    });
  },
  showNavBar: function () {
    return o.sendMessage({ action: "ShowNaviBar" });
  },
  setNavBar: function (e) {
    var r = { action: "ConfigNaviBar", parameters: e };
    return o.sendMessage(r);
  },
  hideNavButton: function (e) {
    var r = { action: "HideNaviButton", parameters: e };
    return o.sendMessage(r);
  },
  showNavButton: function (e) {
    var r = { action: "ShowNaviButton", parameters: e };
    return o.sendMessage(r);
  },
  showModifyButton: function (e) {
    var r = { action: "RightButtonItem", parameters: e };
    return o.sendMessage(r);
  },
  // iOS 是否需要下拉刷新 默认需要 0需要  1不需要
  needFreshAction: function (e = 0) {
    var r = {
      action: "NeedFreshAction",
      parameters: { fresh: e },
    };
    return o.sendMessage(r);
  },
  closeWindow: function () {
    o.sendMessage({ action: "CloseWindow" });
  },
  setNativeRouter: function (e) {
    var r = { action: "Router", parameters: e || {} };
    switch (e.type) {
      case 1:
        r.parameters.ViewController = "PostMindViewController";
        break;
      case 2:
        r.parameters.ViewController = "LiveStreaming";
        break;
      case 3:
        r.parameters.ViewController = "ScimallAssistant";
        break;
      case 4:
        r.parameters.ViewController = "VideoDetailViewController";
        break;
      case 5:
        r.parameters.ViewController = "UserHomePageViewController";
        break;
      case 6:
        r.parameters.ViewController = "MeetingViewController";
        break;
      case 7:
        r.parameters.ViewController = "ArticleDetailViewController";
        break;
      case 8:
        r.parameters.ViewController = "ASCricleTopicListController";
        break;
      case 9:
        r.parameters.ViewController = "WeiboDetailListViewController";
        break;
      case 10:
        r.parameters.ViewController = "TribeHomeViewController";
        break;
      case 11:
        r.parameters.ViewController = "AcademyHomeViewController";
        break;
      case 12:
        r.parameters.ViewController = "MyAuthenticationViewController";
        break;
      case 13:
        r.parameters.ViewController = "EditWorkExperienceController";
        break;
      case 14:
        r.parameters.ViewController = "EduExperienceController";
        break;
      case 15:
        r.parameters.ViewController = "SettingTagsViewController";
        break;
      case 16:
        r.parameters.ViewController = "OrganizationController";
        break;
      case 17:
        r.parameters.ViewController = "SMNaviToHomePage";
        break;
      case 18:
        r.parameters.ViewController = "SMNaviToCirclePage";
        break;
      case 19:
        r.parameters.ViewController = "SMUploadAvatar";
        break;
      case 20:
        r.parameters.ViewController = "SearchFriendViewController";
        break;
      case 21:
        r.parameters.ViewController = "TribeViewController";
        break;
      case 22:
        r.parameters.ViewController = "CheckInViewController";
        break;
      case 23:
        r.parameters.ViewController = "VideoViewController";
        break;
      case 24:
        r.parameters.ViewController = "TasksViewController";
        break;
      case 25:
        r.parameters.ViewController = "TransmitViewController";
        break;
      case 26:
        r.parameters.ViewController = "GetExpectIncomeListController";
        break;
      case 27:
        r.parameters.ViewController = "MyWalletViewController";
        break;
      case 28:
        r.parameters.ViewController = "NewsPictureBrowserController";
        break;
      case 29:
        r.parameters.ViewController = "FeatureDetailViewController";
        break;
      case 30:
        r.parameters.ViewController = "SMNaviToDiscoverPage";
        break;
      case 31:
        r.parameters.ViewController = "SignInViewController";
        break;
      case 32:
        r.parameters.ViewController = "ActivityViewController";
        break;
      case 33:
        r.parameters.ViewController = "OrganizationViewController";
        break;
      case 34:
        r.parameters.ViewController = "MineViewController";
        break;
      case 35:
        r.parameters.ViewController = "VolunteerApproveViewController";
        break;
      case 36:
        r.parameters.ViewController = "MyOrderViewController";
        break;
      case 37:
        r.parameters.ViewController = "SubmitInforViewController";
        break;
      case 38:
        r.parameters.ViewController = "CalendarViewController";
        break;
      case 39:
        r.parameters.ViewController = "CoinDetailSubListViewController";
        break;
      case 40:
        r.parameters.ViewController = "SciencerDetailViewController";
        break;
      case 41:
        r.parameters.ViewController = "EditMySeicnerInfoViewController";
    }
    return (
      e.id && (r.parameters.ID = e.id),
      e.indexType && (r.parameters.indexType = e.indexType),
      delete r.parameters.type,
      delete r.parameters.id,
      o.sendMessage(r)
    );
  },
  webBackUrl: function (e) {
    return i.sendMessage({
      action: "WebBackUrl",
      parameters: { backUrl: e },
    });
  },
  getSN: function (e) {
    var r = { action: "GetSnStr", parameters: { path: e.url } };
    if (e.data) {
      var a = e.data;
      for (name in a) r.parameters[name] = a[name];
    }
    return i.sendMessage(r);
  },
  showMapHelp: function (e) {
    var r = {
      action: "showMapHelp",
      parameters: { path: e.url },
    };
    return console.log(r), i.sendMessage(r);
  },
  setStorage: function (e) {
    return s.sendMessage(
      Object.assign({ action: "KeyValueWrite", parameters: e })
    );
  },
  getStorage: function (e) {
    return s.sendMessage(
      Object.assign({
        action: "KeyValueRead",
        parameters: { Key: e },
      })
    );
  },
  rewardPlan: function (e) {
    var r = { action: "RewardPlan", parameters: { type: e } };
    return i.sendMessage(r);
  },
  goBack: function (e) {
    var r = {
      action: "GoBack",
      callbackID: e.callbackID,
      callbackFunction: e.callbackFunction,
    };
    return o.sendMessage(r);
  },
  setWebBackClose: function () {
    return o.sendMessage({
      action: "WebBackClose",
      parameters: { close: 1 },
    });
  },
  scienceCornerAction: function (e) {
    var r = {
      action: "scienceNumberCornerAction",
      parameters: { isCorner: e.isCorner },
      callbackID: e.callbackID,
      callbackFunction: e.callbackFunction,
    };
    return i.sendMessage(r);
  },
  scienceNumberHomePageAction: function (e) {
    var r = {
      action: "scienceNumberHomePageAction",
      parameters: { scienceNumberId: e },
    };
    return i.sendMessage(r);
  },
  editHeightAction: function (e) {
    return o.sendMessage(
      Object.assign({
        action: "EditHeight",
        parameters: { height: e },
      })
    );
  },
  reEditContent: function (e) {
    var r = Object.assign({}, { action: "ReEditContent", parameters: {} }, e);
    return o.sendMessage(r);
  },
  reEditContentAction: function () {
    return o.sendMessage({
      action: "ReEditContentAction",
      parameters: {},
    });
  },
  joinActivityAction: function (e) {
    var r = {
      action: "joinActivityAction",
      parameters: { scienceNumberId: e },
    };
    return i.sendMessage(r);
  },
  segmentAction: function (e) {
    var r = { action: "segmentAction", parameters: { index: e } };
    return i.sendMessage(r);
  },
  activityDetailAction: function (id) {
    var r = {
      action: "Router",
      parameters: {
        ID: id,
        ViewController: "ActivityDetailViewController",
      },
    };
    return o.sendMessage(r);
  },
};
window.sma = c;
export default c;
